import React, { useEffect, useState } from 'react';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import AppTableContainer from '@projectK/components/AppTableContainer';
import TableHeading from './TableHeading';
import TableItem from './TableItem';
import { Box, Button, Typography, alpha } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import AppsPagination from '@projectK/components/AppsPagination';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Fonts } from '@projectK/constants';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import AppCard from '@projectK/components/AppCard';
import AddParentMembers from './AddParentMembers';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { IonButton } from '@ionic/react';
import {isParent,isActualSuperAdmin ,isActualAdmin} from '@projectK/context/RolesProvider';
const formatRoleName = (roleName) => {
  if (!roleName) return ""; // Return empty string if undefined or null
  return roleName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
const NewParentMembers = () => {
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();
  const { isMobile, mobileMode } = useMobileSettings();
  const mobileResponse = useMediaQuery('(max-width:755px)');
  const { user } = useAuthUser();
  const [settings, setSettings] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleConditionFunction = (condition, ifData, elseData) => {
    if (condition) {
      return ifData;
    } else {
      return elseData;
    }
  };
  useEffect(() => {
    fetchMembersData();
  }, [page]);

  const fetchMembersData = async () => {
    try {
      const response = await jwtAxios.get(`/parentmembers/${user?.id}`, {
        params: {
          page,
          perPage: 5,
        },
      });
      const { data } = response;
      setSettings(data?.list);
      setTotal(response?.data?.total);
      data?.list?.length === 0 && page > 0 && setPage(page - 1);
    } catch (error) {
      setSettings([]);
    }
  };
  const handleDelete = (itemId) => {
    jwtAxios
      .delete(`/users/in-active/${itemId}`)
      .then((response) => {
        fetchMembersData();
        infoViewActionsContext.showMessage('Member deleted successfully!');
      })
      .catch((error) => {
        infoViewActionsContext.fetchError('Error deleting user');
        console.error('Error deleting user:', error);
      });
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };


  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const renderAddParentMemberButton = () => {
    if (isMobile) {
      return (
        <IonButton
          color='primary'
          mode={mobileMode}
          fill='outline'
          size='small'
          onClick={openModal}
          style={{
            marginBottom: 'inherit',
            borderColor: companyTheme ? companyTheme.primary.main : '#2196f3',
            color: companyTheme ? companyTheme.primary.main : '#2196f3',
          }}
        >
          <AddOutlinedIcon sx={{ mr: 1 }} />
          Add Parent Member
        </IonButton>
      );
    } else {
      return (
        <Button
          variant='outlined'
          size='small'
          onClick={openModal}
          sx={{
            position: 'relative',
            ml: 2.5,
            ...(mobileResponse ? { minWidth: 0 } : { minWidth: 100 }),
            borderColor: companyTheme ? companyTheme.primary.main : '#2196f3',
            '&:hover': {
              borderColor: companyTheme
                ? alpha(companyTheme.primary.main, 0.8)
                : alpha('#2196f3', 0.8),
            },
            color: companyTheme ? companyTheme.primary.main : '#2196f3',
          }}
        >
          <AddOutlinedIcon sx={{ mr: 1 }} />
          Add Parent Member
        </Button>
      );
    }
  };
  const table = (
    <AppTableContainer>
      <Table className='table'>
        <TableHead>
          <TableHeading user={user} />
        </TableHead>
        <TableBody>
          {settings?.map((item) => (
            <TableItem
              key={item.id}
              data={item}
              onDelete={handleDelete}
              fetchMembersData={fetchMembersData}
              isMobile={isMobile}
              mobileMode={mobileMode}
              companyTheme={companyTheme}
            />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
  return (
    <AppCard>
      <Typography
        component='h3'
        sx={{
          marginBottom: 2,
          fontSize: 16,
          fontWeight: Fonts.BOLD,
          color: handleConditionFunction(
            companyTheme,
            companyTheme.primary.main,
            'text.primary',
          ),
        }}
      >
        Parent Members
      </Typography>
      <Typography component='h3' sx={{ marginBottom: 5 }}>
        These settings let you add parent members that can be managed by your
        account.
      </Typography>
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        width={1}
        justifyContent={mobileResponse ? 'space-between' : 'end'}
        marginBottom={5}
      >
        <Box display='flex' flexDirection='row' alignItems='center'>
          {isParent(user) ||
          isActualSuperAdmin(user) || isActualAdmin(user)
            ? renderAddParentMemberButton()
            : ''}

        <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <AppsPagination
              rowsPerPage={5}
              count={total}
              page={page}
              onPageChange={onPageChange}
            />
            </Box>
          </Box>
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
          <AppsPagination
            rowsPerPage={5}
            count={total}
            page={page}
            onPageChange={onPageChange}
          />
        </Box>
      </Box>
      {isModalOpen && (<AddParentMembers
        isOpen={isModalOpen}
        onClose={closeModal}
        fetchMembersData={fetchMembersData}
        isMobile={isMobile}
        mobileMode={mobileMode}
        formatRoleName={formatRoleName}
      />)}

      {handleConditionFunction(
        isMobile,
        <div className='mobileapp'>{table}</div>,
        table,
      )}
    </AppCard>
  );
};

export default NewParentMembers;

